import { atom } from 'recoil';

import { CheckBoxFilter } from '@shared/components/CheckboxFilter';

export const agencyAdminAccountTeamNameFilterAtom = atom<CheckBoxFilter | null>({
  key: 'agencyAdminAccountTeamNameFilterAtom',
  default: {},
});
